
export default {
  SET_MANNING_VESSELS(state, data) {
    state.manningVessels = data;
  },
  SET_CREW_ROLES(state, data) {
    state.crewRoles = data;
  },
}
